<template>
  <div>
    <div class="cardLayoutWrapper">
      <BasicTooltip label="Action en attente">
        <div class="elem elem--span-1">
          <BasicIcon
            v-if="item?.avecAlerteActionAFaire"
            name="danger"
            :active="false"
          />
        </div>
      </BasicTooltip>
      <BasicTooltip label="Avec mandat de gestion">
        <div class="elem elem--span-1">
          <BasicIcon
            v-if="item?.estSousMandatGestion"
            name="archive-book"
            active
          />
        </div>
      </BasicTooltip>
      <BasicTooltip label="Avec subrogation">
        <div class="elem elem--span-1">
          <BasicIcon
            v-if="item?.avecSubrogation"
            name="wallet"
          />
        </div>
      </BasicTooltip>
      <div
        class="elem elem--span-3 elem--clickable"
        @click="useRechercheDossierActions().displayDossier(item?.code as string)"
      >
        <span>{{ item?.code }}</span>
      </div>
      <div class="elem elem--span-2">{{ item?.dispositif }}</div>
      <div class="elem elem--span-6 elem--nowrap">
        <span>{{ item?.intitule }}</span>
      </div>
      <div class="elem elem--span-3">{{ dateFormatter(item?.dateDebut) }}</div>
      <div class="elem elem--span-3">{{ dateFormatter(item?.dateFin) }}</div>
      <div class="elem elem--span-5 elem--nowrap">
        <span>{{ item?.etablissementAdherentPrincipal?.denomination }}</span>
      </div>
      <div
        class="elem elem--span-4 elem--clickable elem--nowrap"
        @click="showDrawer = !showDrawer"
      >
        <span>{{ stagiaires }}</span>
      </div>
      <div class="elem elem--span-4">
        <BasicTooltip :label="StatutLibelle[itemStatut]">
          <BasicBadge
            :type="StatutBadgeType[itemStatut]"
            size="medium"
            :deletable="false"
            :label="StatutLibelle[itemStatut]"
          />
        </BasicTooltip>
      </div>
      <div class="elem elem--span-1"></div>
      <div
        v-focusable="{
          onEnter: () => useRechercheDossierActions().displayDossier(item?.code as string),
        }"
        class="elem elem--span-1 elem--clickable"
      >
        <BasicTooltip label="Consulter la demande">
          <BasicIcon
            name="eye"
            :active="false"
            @click="useRechercheDossierActions().displayDossier(item?.code as string)"
          />
        </BasicTooltip>
      </div>
    </div>
    <Transition name="open">
      <div
        v-if="showDrawer && stagiairesList.length"
        class="listDrawerWrapper"
      >
        <div class="content">
          <ListDetails>
            <template #content>
              <div
                class="listDetailsElement"
                v-if="stagiairesList.length"
              >
                <span class="listDetailsTitle">Stagiaire(s)</span>
                <span class="listDetailsSubtitle">
                  {{ stagiairesList }}
                </span>
              </div>
            </template>
          </ListDetails>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue'
  import type { RechercheResultDTO } from '@/features/api/extranet/dto/Dossier/Recherche'
  import { type Statut, StatutBadgeType, StatutLibelle } from '@/features/domaine/types/opco/Dossier'
  import { dateFormatter } from '@/features/shared/tools/date'
  import { useRechercheDossierActions } from '../useRechercheDossierActions'
  import ListDetails from './ListDetails.vue'

  const props = defineProps<{ item: RechercheResultDTO }>()
  const showDrawer = ref(false)

  const stagiaires = computed(() => {
    const stagiaires = props.item.stagiaires
    if (!stagiaires || stagiaires.length === 0) return '-'
    const first = stagiaires[0].prenom + ' ' + stagiaires[0].nom
    const others = stagiaires.length - 1
    return first + (others > 0 ? ` + ${others}` : '')
  })

  const stagiairesList = computed(() => {
    const stagiaires = props.item?.stagiaires
    if (!stagiaires || stagiaires.length === 0) return []

    return stagiaires
      .map((stagiaire) => {
        return (stagiaire.prenom ?? '') + ' ' + (stagiaire.nom ?? '')
      })
      .join(', ')
  })

  const itemStatut = computed<Statut>(() => {
    if (props.item?.statut) {
      return props.item?.statut as Statut
    }
    return 'Transmis'
  })
</script>

<style scoped>
  @import '../../index.less';
</style>
